import React, { useState } from "react";
import Tooltip from "components/Tooltip";
import PropTypes from 'prop-types';

const Input = ({ className, label, tooltip, register: registerProp, error, errorMessage, onError, maxLength, ...rest }) => {
    const [charCount, setCharCount] = useState(0);
    const showCounter = !!maxLength;

    const register = registerProp ? {
        ...registerProp,
        onChange: (e) => {
            setCharCount(e.target.value.length);
            return registerProp.onChange?.(e);
        }
    } : {};

    return (
        <div className={`${className} relative `}>

            {(label || tooltip) &&
                <div className="flex-row items-center mb-2">
                    <label htmlFor={rest.id} className="capitalize flex relative font-medium text-sm text-gray-800 leading-tight tracking-normal ">
                        {label}
                    </label>
                    {!!tooltip && <Tooltip className="ml-2">
                        <p className=" text-sm leading-4 text-gray-600 ">{tooltip}</p>
                    </Tooltip>}
                </div>
            }

            <div className="flex flex-nowrap items-center">
                <input
                    maxLength={maxLength}
                    {...rest}
                    {...register}
                    className="text-gray-600 focus:outline-none focus:border focus:border-blue-700 font-normal w-full h-10 flex items-center p-2 text-sm border-gray-300 rounded border"
                />
            </div>

            <div className="flex justify-between items-center">
                {error
                    ? <div className="text-red-500 text-xs mt-1">{error?.message}</div>
                    : <div />
                }
                {showCounter &&
                    <div className={`text-xs mt-0.5 ${charCount > maxLength ? 'text-red-500' : 'text-gray-400'}`}>
                        {charCount}/{maxLength}
                    </div>
                }
            </div>
        </div>
    );
}

Input.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  tooltip: PropTypes.string,
  register: PropTypes.object,
  error: PropTypes.object,
  errorMessage: PropTypes.string,
  onError: PropTypes.func,
  maxLength: PropTypes.number,
};

export default Input;
